var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveUserSecureLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 5.3335H5.33317M10.6665 5.3335C12.1393 5.3335 13.3332 6.5274 13.3332 8.00016V12.0002C13.3332 13.4729 12.1393 14.6668 10.6665 14.6668H5.33317C3.86041 14.6668 2.6665 13.4729 2.6665 12.0002V8.00016C2.6665 6.5274 3.86041 5.3335 5.33317 5.3335M10.6665 5.3335V4.00016C10.6665 2.5274 9.4726 1.3335 7.99984 1.3335C6.52708 1.3335 5.33317 2.5274 5.33317 4.00016V5.3335M7.99984 10.6668V9.3335",
    stroke: "#181D27",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUserSecureLink);
export default __webpack_public_path__ + "static/media/active_user_secure_link.05c032ed151f9084d9749f8facc83e26.svg";
export { ForwardRef as ReactComponent };